import { useTheme } from "../../framework/theme/mantine-passthroughs.js";
import { rem } from "../../framework/theme/util/misc.js";
import { Anchor as Anchor$1 } from "../anchor/Anchor.js";
import { ActionIcon } from "@mantine/core";
import { forwardRef, useCallback } from "react";
import { jsx } from "react/jsx-runtime";

//#region src/components/icon-button/IconButton.tsx
const btnSize = {
	xs: rem("32px"),
	sm: rem("40px"),
	md: rem("48px"),
	lg: rem("56px")
};
const IconButton = forwardRef(({ Icon, color = "primary", size = "md", disabled = false, onClick, withStyles = true, alt, disableClickColor = false, selected = false, "data-testid": testId }, ref) => {
	const colorProps = useTheme().other.getStyleForColor(color);
	const handleClick = useCallback((event) => {
		event.preventDefault();
		event.stopPropagation();
		onClick?.();
	}, [onClick]);
	if (!withStyles) {
		const anchorSize = `calc(${btnSize[size]} / 2)`;
		return /* @__PURE__ */ jsx(Anchor$1, {
			onClick: handleClick,
			display: "inline-block",
			height: anchorSize,
			width: anchorSize,
			"aria-label": alt,
			"data-testid": testId,
			ref,
			children: /* @__PURE__ */ jsx(Icon, {
				color,
				height: anchorSize,
				width: anchorSize
			})
		});
	}
	return /* @__PURE__ */ jsx(ActionIcon, {
		color: colorProps.bg,
		variant: "subtle",
		disabled,
		radius: "50%",
		size: btnSize[size],
		onClick: handleClick,
		__vars: {
			"--ai-hover": disableClickColor ? "var(--mantine-color-body)" : `var(--mantine-color-${color}-background-hover)`,
			...selected && {
				"--ai-bg": "var(--mantine-color-primary-background)",
				"--ai-hover": "var(--mantine-color-primary-background)",
				"--ai-bd": "1px solid var(--mantine-color-primary-background)",
				"--ai-color": "var(--mantine-color-gray-0)",
				"--ai-hover-color": "var(--mantine-color-gray-0)"
			}
		},
		"aria-label": alt,
		"data-selected": selected || void 0,
		"data-testid": testId,
		ref,
		children: /* @__PURE__ */ jsx(Icon, {
			color: disabled ? "gray" : selected ? "currentColor" : color,
			width: "65%",
			height: "65%"
		})
	});
});
IconButton.displayName = "IconButton";

//#endregion
export { IconButton };